export type SocketCoords = {
  latitude: number;
  longitude: number;
};

export type TenantList = {
  [tenantId: string]: PolicemanList;
}

export type PolicemanList = {
  [policemanId: string]: PolicemanLocation;
}

type PolicemanLocation = {
  coords: SocketCoords;
  token: string;
  working: boolean;
  name?: string;
}

export type PolicemanMapMarkerType =
  | "policeman"
  | "occVehicle"
  | "occPatrimony"
  | "store"
  | "policemanOnDuty";

export type PolicemanMapMarker = {
  id: string;
  coords: SocketCoords;
  type: PolicemanMapMarkerType;
  name?: string;
  working?: boolean;
}

type TreatSocketLocationsParams = {
  socketLocations: TenantList | PolicemanList;
  tenantId: string;
}

function mountLocationList(objList: PolicemanList) {
  return Object.keys(objList).map((key) => {
    const working = objList[key].working;

    const coordinate: PolicemanMapMarker = {
      id: key,
      coords: objList[key].coords,
      type: working ? "policeman" : "policemanOnDuty",
      working: objList[key].working,
      name: objList[key].name,
    };

    return coordinate;
  });
}

export function treatSocketLocations({
  socketLocations,
  tenantId
}: TreatSocketLocationsParams) {
  if (tenantId in socketLocations) {
    return mountLocationList(socketLocations[tenantId] as PolicemanList);
  }

  return mountLocationList(socketLocations as PolicemanList);
}